/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDocumentReviewFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type DocumentReview, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /documents/{id}/review
 */
export interface ReviewRequestBuilder extends BaseRequestBuilder<ReviewRequestBuilder> {
    /**
     * GetDocumentReview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DocumentReview>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DocumentReview | undefined>;
    /**
     * GetDocumentReview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReviewRequestBuilderUriTemplate = "{+baseurl}/documents/{id}/review";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReviewRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ReviewRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDocumentReviewFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
